import { createFileRoute } from '@tanstack/react-router'
import EditUserAccess from 'Administration/components/access/EditUserAccess'

export const Route = createFileRoute('/administration/users/$id/access')({
    component: EditUserAccess,
})
